<template>
    <div 
      class="  px-10 mt-12">
      <v-dialog v-model="dialog.customer"
            @keydown.esc="dialog.customer = false"
            :fullscreen="dialog.fullscreen"
            width="1000"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Tambahkan Varian
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.customer = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.customer = false;"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
  
              <v-card-text class="mt-3">
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  ref="table-grid"
                  class="table-grid"
                  :items="list"
                  height="calc( 100vh - 400px )"
                  elevation="0"
                  hide-default-footer
                  :single-select="false"
                  item-key="id"
                  show-select
                  :items-per-page="1000000000"
                  style="border: 1px solid #E7E7E7;"
                >
                </v-data-table>
              </v-card-text>
              
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="toAdd()"
                  :loading="process.delete"
                  :disabled="process.delete || selected.length < 1"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Pilih
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      <v-layout wrap>
        <v-flex>
          <section>
            
            <div class="color-dark-blue fs-22 font-weight-bold">
              Detail Group Produk
            </div>
  
            <v-row
              class="">
              <v-col 
                cols="12"
                class="px-0">
                <v-card 
                  flat
                  style="border-radius: 25px; border: 1px solid #E7E7E7;">
                  <v-card-text>
                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <!-- <div
                          class="mb-4">
                          <div 
                            class="body-2 mb-2">
                            Poto Profil
                          </div>
  
                          <uploadfolder v-if="form.image_url === ''"
                            v-model="upload.image">
                            <div 
                              slot="activator">
                              <v-card 
                                flat
                                width="200"
                                height="200"
                                class="d-flex align-center justify-center cursor-pointer"
                                style="border-radius: 15px;
                                      border: 2px solid #EBEBEB; 
                                      border-style: dashed;">
                                <v-avatar v-if="!process.image"
                                  v-ripple
                                  tile 
                                  width="200"
                                  height="200">
                                  <v-icon
                                    size="50"
                                    color="#B9B9B9">
                                    mdi-cloud-upload-outline
                                  </v-icon>
                                </v-avatar>
  
                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </v-card>
                            </div>
                          </uploadfolder>
  
                          <v-card v-if="form.image_url !== ''"
                            flat
                            width="200"
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #EBEBEB; 
                                  border-style: dashed;">
                            <v-avatar
                              v-ripple
                              tile 
                              size="200"
                              style="border-radius: 15px;">
                              <v-img 
                                contain
                                width="100%"
                                height="100%"
                                alt="Mitra Warung" 
                                :src="form.image_url"
                                class="ma-auto"
                                style="border-radius: 15px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
  
                            <v-icon 
                              @click="form.image_url = ''"
                              color="red"
                              class="cursor-pointer"
                              style="position: absolute; top: -10px; right: -10px;">
                              mdi-close-circle
                            </v-icon>
                          </v-card>
                        </div> -->
  
                        <v-row>
                          
                          <v-col
                          cols="12"
                          md="5" class="pt-0 pr-8">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Nama Group Produk
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ form.name  }}
                            </div>
                          </div>
  
                            <!-- <ValidationProvider
                              name="Nama" 
                              rules="" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                Nama
                              </div>
        
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#718EBF"
                                placeholder="Nama"
          
                                
          
                                v-model="form.name"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider> -->
  
                            
                          </v-col>
                          
                          <v-col
                            cols="12"
                            md="12" class="pt-0">
  
                            <div class="d-flex align-center">
                              <div class="fs-18 input-label mb-5">
                                Data Produk
                              </div>
                              <!-- <div class="ml-auto">
                                <v-btn
                                  color="#1814F3"
                                  width="195"
                                  small
                                  height="35"
                                  elevation="0"
                                  style="border-radius: 9px;"
                                  @click="openDialog()"
                                  class="fs-14 white--text text-capitalize">
                                  <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                                  Tambah Varian
                                </v-btn>
                              </div> -->
                            </div>
                            <v-divider class="my-2"></v-divider>
  
                            <v-card flat>
                              <v-card-text
                                v-if="form.varian_arr.length < 1"
                                class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                                <div class="text-center">
                                  <v-img 
                                    class="mx-auto"
                                    contain
                                    alt="vuetify"
                                    :width="90"
                                    :height="90"
                                    :src="require('@/assets/image/empty.png')">
                                    <!-- <template v-slot:placeholder>
                                      <v-row
                                        class=" "
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template> -->
                                  </v-img>
                                  <div class="mt-3 fs-18">
                                    Belum Ada Varian
                                  </div>
                                </div>
                              </v-card-text>
  
                              <v-card-text
                                v-else
                                class="pb-0 my-4" style="height: calc( 100vh - 350px );">
                                <v-data-table
                                  v-model="form.varian_arr"
                                  :headers="configHeaders"
                                  :items="form.varian_arr"
                                  ref="table-grid"
                                  class="table-grid"
                                  height="calc( 100vh - 350px )"
                                  elevation="0"
                                  hide-default-footer
                                  :single-select="false"
                                  item-key="id"
                                  :items-per-page="1000000000"
                                >
                                <template
                                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                                    v-slot:[`item.${header.value}`]="{ value }">
                                  <div
                                    v-bind:key="header.value">
                                    <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                                      {{ rowFormat(header.format, value) }} 
                                    </div>
                  
                                    <div v-if="header.format === 'link'"
                                      class="cursor-pointer">
                                      
                                    </div>
                      
                                    <div v-if="header.format === 'regex'">
                                      <span
                                        class="two-line">
                                        {{ rowFormat(header.format, value) }}
                                      </span>
                                    </div>
                      
                                    <div v-if="header.format === 'image'"
                                      class="ma-4">
                                      <v-avatar
                                        size="60"
                                        tile
                                        style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                        <v-img 
                                          contain
                                          width="100%"
                                          height="100%"
                                          alt="Mitra Warung" 
                                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                          class="ma-auto">
                                          <template v-slot:placeholder>
                                            <v-row
                                              class="fill-height"
                                              align="center"
                                              justify="center">
                                              <v-progress-circular 
                                                size="20"
                                                indeterminate 
                                                color="#718EBF">
                                              </v-progress-circular>
                                            </v-row>
                                          </template>
                                        </v-img>
                                      </v-avatar>
                                    </div>
                  
                                    <div v-if="header.format === 'image_potrait'"
                                      class="ma-4">
                                      <v-img 
                                        contain
                                        width="100"
                                        height="125"
                                        alt="Mitra Warung" 
                                        :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                        class="ma-auto"
                                        style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                        <template v-slot:placeholder>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center">
                                            <v-progress-circular 
                                              size="20"
                                              indeterminate 
                                              color="#718EBF">
                                            </v-progress-circular>
                                          </v-row>
                                        </template>
                                      </v-img>
                                    </div>
                  
                                    <div v-if="header.format === 'image_landscape'"
                                      class="ma-4">
                                      <v-img 
                                        contain
                                        width="200"
                                        height="125"
                                        alt="Mitra Warung" 
                                        :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                        class="ma-auto"
                                        style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                        <template v-slot:placeholder>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center">
                                            <v-progress-circular 
                                              size="20"
                                              indeterminate 
                                              color="#718EBF">
                                            </v-progress-circular>
                                          </v-row>
                                        </template>
                                      </v-img>
                                    </div>
                  
                                    <div v-if="header.format === 'action'">
  
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          
                                            @click="form.varian_arr.splice(index, 1)"
  
                                            v-bind="attrs"
                                            v-on="on"
  
                                            min-width="28"
                                            small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon small>mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
                                        
                                        <span>Hapus</span>
                                      </v-tooltip>
                                      <!-- <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            outlined
                                            rounded
                                            v-bind="attrs"
                                            v-on="on"
                                            elevation="0"
                                            color="#1814F3"
                                            height="35"
                                            width="100"
                                            class="text-capitalize ma-2"
                                            :to="`/customer/edit/${value}`"
                                          >
                                            Ubah
                                          </v-btn>
                                        </template>
                  
                                        <span>Ubah</span>
                                      </v-tooltip>
                                      <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          outlined
                                          rounded
                                          v-bind="attrs"
                                          v-on="on"
                                          elevation="0"
                                          color="#16DBCC"
                                          height="35"
                                          width="100"
                                          class="text-capitalize ma-2"
                                          :to="`/customer/${value}`"
                                        >
                                          Detail
                                        </v-btn>
                                      </template>
  
                                      <span>Detail</span>
                                    </v-tooltip>
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            outlined
                                            rounded
                                            v-bind="attrs"
                                            v-on="on"
                                            elevation="0"
                                            color="red"
                                            height="35"
                                            width="100"
                                            class="text-capitalize ma-2"
                                            @click="toDelete(value)"
                                          >
                                            Hapus
                                          </v-btn>
                                        </template>
                  
                                        <span>Hapus</span>
                                      </v-tooltip> -->
                                    </div>
                  
                                    <div v-if="header.format === 'status'"
                                      class="d-flex justify-start text-capitalize font-weight-medium" :class="value == 'Publish' ? 'blue--text text--darken-2' : 'red--text'">
                                      {{ value }}
                                    </div>
                                  </div>
                                </template>
                                <template v-slot:[`item.index`]="{ index }">
                                  {{ lastIndex + index }}
                                </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
  
                      </v-form>
                    </ValidationObserver>
  
                    <div v-if="message.error.length > 0"
                      class="text-center my-4 d-flex align-center">
                      <div
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>


                <v-card 
                  flat
                  class="mt-4"
                  style="border-radius: 25px; border: 1px solid #E7E7E7;">
                  <v-card-text>
                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <!-- <div
                          class="mb-4">
                          <div 
                            class="body-2 mb-2">
                            Poto Profil
                          </div>
  
                          <uploadfolder v-if="form.image_url === ''"
                            v-model="upload.image">
                            <div 
                              slot="activator">
                              <v-card 
                                flat
                                width="200"
                                height="200"
                                class="d-flex align-center justify-center cursor-pointer"
                                style="border-radius: 15px;
                                      border: 2px solid #EBEBEB; 
                                      border-style: dashed;">
                                <v-avatar v-if="!process.image"
                                  v-ripple
                                  tile 
                                  width="200"
                                  height="200">
                                  <v-icon
                                    size="50"
                                    color="#B9B9B9">
                                    mdi-cloud-upload-outline
                                  </v-icon>
                                </v-avatar>
  
                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </v-card>
                            </div>
                          </uploadfolder>
  
                          <v-card v-if="form.image_url !== ''"
                            flat
                            width="200"
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #EBEBEB; 
                                  border-style: dashed;">
                            <v-avatar
                              v-ripple
                              tile 
                              size="200"
                              style="border-radius: 15px;">
                              <v-img 
                                contain
                                width="100%"
                                height="100%"
                                alt="Mitra Warung" 
                                :src="form.image_url"
                                class="ma-auto"
                                style="border-radius: 15px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
  
                            <v-icon 
                              @click="form.image_url = ''"
                              color="red"
                              class="cursor-pointer"
                              style="position: absolute; top: -10px; right: -10px;">
                              mdi-close-circle
                            </v-icon>
                          </v-card>
                        </div> -->
  
                        <v-row>
                          
                          <v-col
                            cols="12"
                            md="12" class="pt-0">
  
                            <div class="d-flex align-center">
                              <div class="fs-18 input-label mb-5">
                                Data Sales
                              </div>
                              <!-- <div class="ml-auto">
                                <v-btn
                                  color="#1814F3"
                                  width="195"
                                  small
                                  height="35"
                                  elevation="0"
                                  style="border-radius: 9px;"
                                  @click="openDialog()"
                                  class="fs-14 white--text text-capitalize">
                                  <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                                  Tambah Varian
                                </v-btn>
                              </div> -->
                            </div>
                            <v-divider class="my-2"></v-divider>
  
                            <v-card flat>
  
                              <v-card-text
                                class="pb-0 my-4" style="height: calc( 100vh - 350px );">
                                <v-data-table
                                  v-model="form.sales_arr"
                                  :headers="configHeaders_sales"
                                  :items="form.sales_arr"
                                  ref="table-grid"
                                  class="table-grid"
                                  height="calc( 100vh - 350px )"
                                  elevation="0"
                                  hide-default-footer
                                  :single-select="false"
                                  item-key="user_id"
                                  :items-per-page="1000000000"
                                >
                                <template
                                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                                    v-slot:[`item.${header.value}`]="{ value }">
                                  <div
                                    v-bind:key="header.value">
                                    <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                                      {{ rowFormat(header.format, value) }} 
                                    </div>
                  
                                    <div v-if="header.format === 'link'"
                                      class="cursor-pointer">
                                      
                                    </div>
                      
                                    <div v-if="header.format === 'regex'">
                                      <span
                                        class="two-line">
                                        {{ rowFormat(header.format, value) }}
                                      </span>
                                    </div>
                      
                                    <div v-if="header.format === 'image'"
                                      class="ma-4">
                                      <v-avatar
                                        size="60"
                                        tile
                                        style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                        <v-img 
                                          contain
                                          width="100%"
                                          height="100%"
                                          alt="Mitra Warung" 
                                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                          class="ma-auto">
                                          <template v-slot:placeholder>
                                            <v-row
                                              class="fill-height"
                                              align="center"
                                              justify="center">
                                              <v-progress-circular 
                                                size="20"
                                                indeterminate 
                                                color="#718EBF">
                                              </v-progress-circular>
                                            </v-row>
                                          </template>
                                        </v-img>
                                      </v-avatar>
                                    </div>
                  
                                    <div v-if="header.format === 'image_potrait'"
                                      class="ma-4">
                                      <v-img 
                                        contain
                                        width="100"
                                        height="125"
                                        alt="Mitra Warung" 
                                        :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                        class="ma-auto"
                                        style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                        <template v-slot:placeholder>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center">
                                            <v-progress-circular 
                                              size="20"
                                              indeterminate 
                                              color="#718EBF">
                                            </v-progress-circular>
                                          </v-row>
                                        </template>
                                      </v-img>
                                    </div>
                  
                                    <div v-if="header.format === 'image_landscape'"
                                      class="ma-4">
                                      <v-img 
                                        contain
                                        width="200"
                                        height="125"
                                        alt="Mitra Warung" 
                                        :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                        class="ma-auto"
                                        style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                        <template v-slot:placeholder>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center">
                                            <v-progress-circular 
                                              size="20"
                                              indeterminate 
                                              color="#718EBF">
                                            </v-progress-circular>
                                          </v-row>
                                        </template>
                                      </v-img>
                                    </div>
                  
                                    <div v-if="header.format === 'action'">
  
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          
                                            @click="form.varian_arr.splice(index, 1)"
  
                                            v-bind="attrs"
                                            v-on="on"
  
                                            min-width="28"
                                            small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon small>mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
                                        
                                        <span>Hapus</span>
                                      </v-tooltip>
                                      <!-- <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            outlined
                                            rounded
                                            v-bind="attrs"
                                            v-on="on"
                                            elevation="0"
                                            color="#1814F3"
                                            height="35"
                                            width="100"
                                            class="text-capitalize ma-2"
                                            :to="`/customer/edit/${value}`"
                                          >
                                            Ubah
                                          </v-btn>
                                        </template>
                  
                                        <span>Ubah</span>
                                      </v-tooltip>
                                      <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          outlined
                                          rounded
                                          v-bind="attrs"
                                          v-on="on"
                                          elevation="0"
                                          color="#16DBCC"
                                          height="35"
                                          width="100"
                                          class="text-capitalize ma-2"
                                          :to="`/customer/${value}`"
                                        >
                                          Detail
                                        </v-btn>
                                      </template>
  
                                      <span>Detail</span>
                                    </v-tooltip>
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            outlined
                                            rounded
                                            v-bind="attrs"
                                            v-on="on"
                                            elevation="0"
                                            color="red"
                                            height="35"
                                            width="100"
                                            class="text-capitalize ma-2"
                                            @click="toDelete(value)"
                                          >
                                            Hapus
                                          </v-btn>
                                        </template>
                  
                                        <span>Hapus</span>
                                      </v-tooltip> -->
                                    </div>
                  
                                    <div v-if="header.format === 'status'"
                                      class="d-flex justify-start text-capitalize font-weight-medium" :class="value == 'Publish' ? 'blue--text text--darken-2' : 'red--text'">
                                      {{ value }}
                                    </div>
                                  </div>
                                </template>
                                <template v-slot:[`item.index`]="{ index }">
                                  {{ lastIndex + index }}
                                </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
  
                      </v-form>
                    </ValidationObserver>
  
                    <div v-if="message.error.length > 0"
                      class="text-center my-4 d-flex align-center">
                      <div
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              justify="end"
              class="pa-4 pt-0 pr-1">
              <v-col 
                cols="12"
                md="12"
                class="d-flex align-center justify-end py-0">
                <!-- <v-btn 
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Simpan
                </v-btn> -->
                
                <v-btn
                  to="/product/group"
                  :disabled="process.form"
                  color="red"
                  elevation="0"
                  width="140"
                  height="45"
                  class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                  style="font-weight: 600;">
                
                    Batal
                </v-btn>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
  
          dialog: {
            customer: false,
            fullscreen: false
          },
          selected: [],
          headers: [],
          list: [],
          form: {
            name: '',
            varian_arr: [],
            sales_arr: [],
          },
          headers_data_sales: [],
          headers_data: [],
          category: [],
          supervisor: [],
          branch: [],
  
          mobilephone: {
            name: '',
            id: ''
          },
  
          lastIndex: 1,
  
          upload: {
            ttd: null,
            image_url: null
          },
  
          process: {
            form: false,
  
            ttd: false,
  
            image_url: false
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.ttd': {
          handler: function () {
            if (this.upload.ttd) {
              this.process.ttd = this.upload.ttd.process
  
              if (!this.process.ttd) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.ttd = this.upload.ttd.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
  
        'upload.image_url': {
          handler: function () {
            if (this.upload.image_url) {
              this.process.image_url = this.upload.image_url.process
  
              if (!this.process.image_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        }
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
        configHeaders () {
            return this.headers_data.filter(header => !header.hide)  
          },

          configHeaders_sales () {
            return this.headers_data_sales.filter(header => !header.hide)  
          },
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail () {
          let params = {
            id: this.$route.params.id
          }
  
          await get('admin/product_group/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.headers_data_sales = [
                  {
                    text: 'No',
                    width: '80',
                    value: 'index',
                    freeze: true,
                    hide: false
                  },
                  {
                    text: 'Nama',
                    width: '100%',
                    value: 'user_name',
                    freeze: true,
                    hide: false
                  }
                ]
              // this.form = res.results.data
              this.form.varian_arr = res.results.data.varian
              this.form.name = res.results.data.name
              this.form.id = res.results.data.id
              this.form.sales_arr = res.results.data.sales
            }
            this.fetchCustomor()
          })
        },
        async fetchCustomor () {
            // this.process.load = true
    
            // this.limit = pagination.row
    
            let params = {
              limit: 10000000000000,
            }
    
            // admin/services/data
            
            await get(`admin/varian/data`, { params })
            .then(response => {
              let res = response.data
              
              this.process.load = false
              
              this.list = []
              this.pagination = {}
              
              if (res.status === 200) {
                this.headers = [
                  // {
                  //   text: 'No',
                  //   width: '80',
                  //   value: 'index',
                  //   freeze: true,
                  //   hide: false
                  // },
                  {
                    text: 'Nama',
                    width: '300px',
                    value: 'name',
                    freeze: true,
                    hide: false
                  },
                  {
                    text: 'SKU',
                    width: '180px',
                    value: 'sku',
                    freeze: false,
                    hide: false
                  },
                  {
                    text: 'Produk',
                    width: '200px',
                    value: 'product_name',
                    freeze: false,
                    hide: false
                  },
                
                ]
  
                this.headers_data = [
                  {
                    text: 'No',
                    width: '80',
                    value: 'index',
                    freeze: true,
                    hide: false
                  },
                  {
                    text: 'Nama',
                    width: '300px',
                    value: 'name',
                    freeze: true,
                    hide: false
                  },
                  {
                    text: 'SKU',
                    width: '180px',
                    value: 'sku',
                    freeze: false,
                    hide: false
                  },
                  {
                    text: 'Produk',
                    width: '200px',
                    value: 'product_name',
                    freeze: false,
                    hide: false
                  },
  
                  // {
                  //   text: '',
                  //   width: '100px',
                  //   value: 'id',
                  //   freeze: true,
                  //   hide: false,
                  //   align: 'right',
                  //   format: 'action'
                  // },
                
                ]
        
                this.list = res.results.data
  
                if (this.form.varian_arr.length > 0) {
                  // this.form.varian_arr = this.list.filter((item) => this.form.varian_arr.includes(item.customer_id))
                  this.form.varian_arr = res.results.data.filter((elem) => this.form.varian_arr.find(({ varian_id }) => elem.id === varian_id))
                }
                
  
                // this.form.varian_arr = this.list.filter((item) => this.form.varian_arr.includes(item.id))
              }
            })
          },
        openDialog () {
          this.selected = []
          this.selected.push(...this.form.varian_arr)
          this.dialog.customer = true
        },
        toAdd() {
          this.form.varian_arr = []
          this.dialog.customer = false
          this.form.varian_arr.push(...this.selected)
          // this.form.varian_arr = this.selected
        },
        addFreezes () {
            this.removeFreezes()
    
            this.selected.freeze = []
    
            for (let i = 0; i < this.configHeaders.length; i++) {
              if (this.configHeaders[i].freeze) {
                // ADD TO SELECTOR
                this.selected.freeze.push({
                  child: i + (this.checkbox ? 2 : 1),
                  width: this.configHeaders[i].width.split('px')[0]
                })
    
                // LOOP STYLESHEET
                for (let f = 0; f < this.selected.freeze.length; f++) {
                  let style = document.createElement('style'),
                      width = 0
    
                  if (this.checkbox) {
                    width = f < 1 ? '65' : 
                          f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                          parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                  } else {
                    width = f < 1 ? '0' : 
                          f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                          parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                  }
    
                  // ADD STYLESHET TO FREEZE
                  style.innerHTML = `
                    .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                      left: ${width}px;
                      z-index: 5;
                      background: #FFFFFF;
                    }
    
                    .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                      left: ${width}px;
                      z-index: 1;
                    }
                  `
    
                  // ADD TO APPENDCHILD
                  document.head.appendChild(style)
                }
              }
            }
          },
          removeFreezes () {
            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style')
              
              // RESET STYLESHEET TO AUTO
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: auto;
                  z-index: auto;
                  background: #FFFFFF;
                }
    
                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: auto;
                  z-index: auto;
                }
              `
    
              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          },
          addHides () {
            if (this.headers.length < 6) this.getTableToResize()
          },
          getTableToResize () {
            let tables = document.getElementsByTagName('table')
    
            for (let i = 0; i < tables.length; i++) {
              this.resizableGrid(tables[i])
            }
          },
          resizableGrid (table) {
            let row = table.getElementsByTagName('tr')[0],
                cols = row ? row.children : undefined
            
            if (!cols) return
            
            table.style.overflow = 'hidden'
            
            let tableHeight = table.offsetHeight
            
            for (let i = 0; i < cols.length; i++) {
              let div = createDiv(tableHeight)
              cols[i].appendChild(div)
              cols[i].style.position = 'relative'
    
              setListeners(div)
            }
    
            function setListeners (div) {
              let pageX, curCol, nxtCol, curColWidth, nxtColWidth
    
              div.addEventListener('mousedown', e => {
                curCol = e.target.parentElement
                nxtCol = curCol.nextElementSibling
                pageX = e.pageX
                
                let padding = paddingDiff(curCol)
                
                curColWidth = curCol.offsetWidth - padding
    
                if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
              })
    
              div.addEventListener ('mouseover', e => {
                e.target.style.borderRight = '2px solid #e0e0e0'
              })
    
              div.addEventListener ('mouseout', e => {
                e.target.style.borderRight = ''
              })
    
              document.addEventListener ('mousemove', e => {
                if (curCol) {
                  let diffX = e.pageX - pageX
              
                  if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
    
                  curCol.style.width = (curColWidth + diffX)+'px'
                }
              })
    
              document.addEventListener ('mouseup', () => { 
                curCol = undefined
                nxtCol = undefined
                pageX = undefined
                nxtColWidth = undefined
                curColWidth = undefined
              })
            }
    
            function createDiv (height) {
              let div = document.createElement('div')
    
              div.style.top = 0
              div.style.right = 0
              div.style.width = '1px'
              div.style.position = 'absolute'
              div.style.cursor = 'col-resize'
              div.style.userSelect = 'none'
              div.style.height = height + 'px'
              div.style.background = '#e0e0e0'
    
              return div
            }
    
            function paddingDiff (col) {
              if (getStyleVal(col,'box-sizing') == 'border-box') {
                return 0
              }
              
              let padLeft = getStyleVal(col,'padding-left')
              let padRight = getStyleVal(col,'padding-right')
    
              return (parseInt(padLeft) + parseInt(padRight))
            }
    
            function getStyleVal (elm,css) {
              return (window.getComputedStyle(elm, null).getPropertyValue(css))
            }
          },
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
          if (isValid) {
            let form = {
              ...this.form,
              varian_arr: JSON.stringify(this.form.varian_arr.map((item) => item.id))
            }
            this.process.form = true
  
            // SAVE TO REST API
            await post(`admin/product_group/update`, {
              data: form
            })
            .then((response) => {
              let res = response.data
  
              this.process.form = false
  
              if (res.status === 200) {
  
                this.$router.push({ path: '/product/group' })
  
              } else {
                this.message.error = res.message
              }
            })
            
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        }
      }
    }
  </script>